module.exports = __webpack_public_path__ + "img/pijl-driehoek-home-mobiel.ad1a2d4ee340133d1feeb9a484c31cc7.svg";